module.exports = __webpack_public_path__ + "static/media/LogicWheel2_2_drag_2.026677d0.png";